import { render, staticRenderFns } from "./cities.vue?vue&type=template&id=04f3318a&scoped=true&"
import script from "./cities.vue?vue&type=script&lang=js&"
export * from "./cities.vue?vue&type=script&lang=js&"
import style0 from "./cities.vue?vue&type=style&index=0&id=04f3318a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f3318a",
  null
  
)

export default component.exports